'use strict';

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol['for'] && Symbol['for']("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _hfReactHelper = require('common/utils/hf-react-helper');

var _hfReactHelper2 = _interopRequireDefault(_hfReactHelper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var PeekABoo = _react2['default'].createClass({
    displayName: 'PeekABoo',


    propTypes: {
        imageUrl: _react2['default'].PropTypes.string,
        imageHeight: _react2['default'].PropTypes.number,
        imageWidth: _react2['default'].PropTypes.number
    },

    componentDidMount: function componentDidMount() {
        var peekYPos = $('.m-peek-a-boo--parallax img').offset().top;
        var scrollBottom = $(window).scrollTop() + $(window).height();
        if (scrollBottom > peekYPos - 150) {
            $('.m-peek-a-boo--parallax img').addClass('is-visible');
        }
        $(window).scroll(function () {
            var scrollBottom = $(window).scrollTop() + $(window).height();
            if (scrollBottom > peekYPos - 150) {
                $('.m-peek-a-boo--parallax img').addClass('is-visible');
            }
        });
    },

    render: function render() {
        return _jsx('div', {
            className: 'm-peek-a-boo ',
            'data-equalizer-watch': true
        }, void 0, _jsx('div', {
            className: 'l-vertical-align m-peek-a-boo--parallax m-feature--outer-container'
        }, void 0, _jsx('img', {
            className: 'm-peek-a-boo--image',
            'data-speed': '.4',
            height: this.props.imageHeight,
            width: this.props.imageWidth,
            src: _hfReactHelper2['default'].imgHelper(this.props.imageUrl)
        })));
    }
});
module.exports = PeekABoo;


/*****************
 ** WEBPACK FOOTER
 ** ./src/common/components/peekaboo.jsx
 ** module id = 616
 ** module chunks = 0
 **/